<app-preloader></app-preloader>
<main class="main auth" role="main">
  <router-outlet> </router-outlet>
</main>
